import React, { useState, useRef, useEffect } from "react";

import {
  MdOutlineKeyboardArrowRight,
  MdOutlineKeyboardArrowLeft,
} from "react-icons/md";
import { IoTrendingUpOutline } from "react-icons/io5";
import { LiaFireAltSolid } from "react-icons/lia";
import { LuChartNoAxesColumn } from "react-icons/lu";
import { PiPlantFill } from "react-icons/pi";
import { IoEyeOutline } from "react-icons/io5";

const SortListSmall = () => {
  const sortItems = [
    {
      name: "Top",
      icon: <LuChartNoAxesColumn className="text-indigo-500 text-base" />,
    },
    {
      name: "Trending",
      icon: <LiaFireAltSolid className="text-red-500 text-base" />,
    },
    {
      name: "New",
      icon: <PiPlantFill className="text-purple-500 text-base" />,
    },
    {
      name: "Gainers",
      icon: <IoTrendingUpOutline className="text-green-500 text-base" />,
    },
    {
      name: "Most Visited",
      icon: <IoEyeOutline className="text-cyan-500 text-base" />,
    },
  ];

  // ✅ load from localStorage
  const [active, setActive] = useState(
    () => localStorage.getItem("activeSortItemSmall") || sortItems[0].name
  );

  // ✅ save to localStorage on change
  useEffect(() => {
    localStorage.setItem("activeSortItemSmall", active);
  }, [active]);

  const scrollRef = useRef(null);

  const scrollRight = () => {
    if (!scrollRef.current) return;

    scrollRef.current.scrollBy({
      left: 200,
      behavior: "smooth",
    });
  };

  const scrollLeft = () => {
    if (!scrollRef.current) return;

    scrollRef.current.scrollBy({
      left: -200,
      behavior: "smooth",
    });
  };

  return (
    <div
      ref={scrollRef}
      className="w-full flex-col justify-center overflow-x-auto no-scrollbar items-center flex mt-3"
    >
      <span
        onClick={scrollRight}
        className="border border-gray-800 bg-gray-900 md:hidden -translate-y-1/2 z-10 outline-none focus:outline-none text-gray-500 text-xl flex justify-center items-center w-5 h-5 rounded-full absolute right-0 mr-2"
      >
        <MdOutlineKeyboardArrowRight />
      </span>

      <span
        onClick={scrollLeft}
        className="border border-gray-800 bg-gray-900 md:hidden outline-none focus:outline-none text-gray-500 text-xl flex justify-center items-center w-5 h-5 rounded-full absolute left-0 ml-2"
      >
        <MdOutlineKeyboardArrowLeft />
      </span>

      <div className="inline-flex md:ml-20 md:justify-start md:w-full items-center md:gap-16 md:px-4">
        {sortItems.map((item, index) => (
          <a
            onClick={() => setActive(item.name)} // ✅ persists
            key={index}
            href="/"
            className={`flex justify-center items-center rounded-lg md:px-6 ${
              active == item.name
                ? "bg-gray-900 text-indigo-200 font-bold"
                : "bg-none text-gray-600 font-medium"
            } py-3 md:py-2 outline-none focus:outline-none shrink-0 w-24 md:w-auto text-xs whitespace-nowrap`}
          >
            <span className="mr-1">{item.icon}</span>
            <span>{item.name}</span>
          </a>
        ))}
      </div>
    </div>
  );
};

export default SortListSmall;
